import { useEffect, useRef } from 'react';

import logger from '@eneco/common/log';

import { signOutWithOkta } from './signOutWithOkta';
import { useSession } from './useSession';

export const TOKEN_EXPIRED_MESSAGE = { type: 'TOKEN_EXPIRED' } as const;

export const SessionExpiryHandler = () => {
  const { data } = useSession();
  const hasHandledExpiry = useRef(false);

  useEffect(() => {
    if (data?.error !== 'RefreshAccessTokenError') {
      hasHandledExpiry.current = false;
      return;
    }

    if (hasHandledExpiry.current) {
      return;
    }

    hasHandledExpiry.current = true;

    if (data.authSource === 'nativeApp') {
      window.postMessage(TOKEN_EXPIRED_MESSAGE, window.location.origin);
      return;
    }

    void signOutWithOkta().catch(error => {
      logger.error('sOut01', 'Failed to sign out after session refresh error', error);
    });
  }, [data?.authSource, data?.error]);

  return null;
};
